export default "/images/subscription_pin_btn.svg?ff41ce22ddc0dd7f6637f07dbbaf039d";